export default __webpack_public_path__ + "727ec7bfdb98408d6f1113a4c6c82f06.png";